module.exports = __webpack_public_path__ + "img/scroll.e40024f3.svg";